import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageSEO } from '../utils/seoData';

const SEOHead = () => {
  const location = useLocation();

  useEffect(() => {
    const seo = getPageSEO(location.pathname);
    
    if (!seo) return;

    // تحديث العنوان
    document.title = seo.title;

    // تحديث أو إضافة meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Meta tags أساسية
    if (seo.description) {
      updateMetaTag('description', seo.description);
    }
    
    if (seo.keywords) {
      updateMetaTag('keywords', seo.keywords);
    }

    // Open Graph tags
    if (seo.ogTitle) {
      updateMetaTag('og:title', seo.ogTitle, true);
    }
    
    if (seo.ogDescription) {
      updateMetaTag('og:description', seo.ogDescription, true);
    }
    
    if (seo.ogType) {
      updateMetaTag('og:type', seo.ogType, true);
    }

    if (seo.ogImage) {
      updateMetaTag('og:image', seo.ogImage, true);
    }

    // Twitter Card tags
    if (seo.ogTitle) {
      updateMetaTag('twitter:title', seo.ogTitle);
    }
    
    if (seo.ogDescription) {
      updateMetaTag('twitter:description', seo.ogDescription);
    }

    if (seo.ogImage) {
      updateMetaTag('twitter:image', seo.ogImage);
      updateMetaTag('twitter:card', 'summary_large_image');
    }

    // Canonical URL
    if (seo.canonical) {
      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      
      const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
      canonical.href = `${baseUrl}${seo.canonical}`;
      
      // تحديث og:url أيضاً
      updateMetaTag('og:url', `${baseUrl}${seo.canonical}`, true);
    }

    // Schema.org JSON-LD
    if (seo.schema) {
      let script = document.querySelector('script[type="application/ld+json"]');
      
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      
      script.textContent = JSON.stringify(seo.schema);
    }

    // تحديث last-modified
    const today = new Date().toISOString().split('T')[0];
    updateMetaTag('last-modified', today);
  }, [location.pathname]);

  return null;
};

export default SEOHead;
